export const INTERVENTION_CATEGORIES = {
  SOCCORSO: 'Soccorso',
  INCENDIO: 'Incendio',
  STRADALE: 'Stradale',
  ALTRO: 'Altro',
} as const;

export type InterventionCategory =
  (typeof INTERVENTION_CATEGORIES)[keyof typeof INTERVENTION_CATEGORIES];

export const INTERVENTION_SUGGESTED_NOTES: Record<InterventionCategory, string[]> = {
  [INTERVENTION_CATEGORIES.SOCCORSO]: ['Persona in difficolta', 'Apertura porta', 'Soccorso animali'],
  [INTERVENTION_CATEGORIES.INCENDIO]: ['Incendio abitazione', 'Incendio bosco', 'Incendio auto'],
  [INTERVENTION_CATEGORIES.STRADALE]: ['Incidente stradale', 'Albero su strada', 'Allagamento strada'],
  [INTERVENTION_CATEGORIES.ALTRO]: ['Esercitazione', 'Manutenzione', 'Altro'],
};
